import { CourseData } from '@containers/activity-router/data-grid-container/courses/types/courses.types';
import { getTopicKey } from '@containers/activity-router/routes/helpers/keys/key-generator';
import {
    TransformCourse
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

type GetNewCoursesFilteredCourseProps = {
    course: CourseData
    filterStrand?: string[]
    filterTopic?: string[]
};

export const getNewCoursesFilteredCourse = ({
    course,
    filterStrand = [],
    filterTopic = []
}: GetNewCoursesFilteredCourseProps) => {
    if (!course) return { updatedCourse: course };

    const filterStrandSet = new Set(filterStrand);
    const filterTopicSet = new Set(filterTopic);
    const hasStrandTopicFilter = filterStrandSet.size > 0 || filterTopicSet.size > 0;
    const filteredTopics = course.topics?.flatMap((strand) => {
        const topics = strand.topics?.flatMap((topic) => {
            const isStrandSelected = filterStrandSet.has(strand.id);
            const isTopicSelected = filterTopicSet.has(topic.id);
            const passStrandTopic =
                !hasStrandTopicFilter ||
                isStrandSelected ||
                isTopicSelected;

            if (!passStrandTopic) return [];

            return topic.activities.length ? [topic] : [];
        });

        return topics?.length ? [{
            ...strand,
            topics
        }] : [];
    });
    const updatedCourse: TransformCourse = {
        ...course,
        topics: filteredTopics
    };

    return { updatedCourse };
};

export const getNewCoursesFilteredTopicKeys = ({
    course,
    filterStrand = [],
    filterTopic = []
}: GetNewCoursesFilteredCourseProps) => {
    if (!course || (filterStrand.length === 0 && filterTopic.length === 0)) return undefined;

    const { updatedCourse } = getNewCoursesFilteredCourse({
        course,
        filterStrand,
        filterTopic
    });

    return updatedCourse?.topics.flatMap((strand) => strand.topics?.map((topic) => getTopicKey({
        strandId: strand.id,
        topicId: topic.id
    })) || []) || [];
};
